import { render, staticRenderFns } from "./kosmoEditor.vue?vue&type=template&id=43f06649&scoped=true"
import script from "./kosmoEditor.vue?vue&type=script&lang=js"
export * from "./kosmoEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43f06649",
  null
  
)

export default component.exports